import React from "react";
import FormTemplate from "../../../../common/templates";

const questions = [
  {
    value: "Is this an Emergency?",
    name: "start0.isEmergency",
  },
  {
    value:
      "Are you reporting the theft of a vehicle of any kind? For example, car, truck, atv, snowmobile or trailer.",
    name: "start0.isReportingTheftOfVehicle",
  },
  {
    value: "Are there any known suspects?",
    name: "start0.haveKnownSuspects",
  },
];

export default function Start({ step }) {
  switch (step) {
    case "0":
      return (
        <div>
          <FormTemplate
            templateName="confirm-questions"
            questions={questions}
          />
        </div>
      );
    case "1":
      return (
        <div>
          <FormTemplate templateName="report-type-selection" formKey="meta" />
        </div>
      );
    case "2":
      return (
        <div>
          <FormTemplate templateName="person-type-selection" formKey="meta" />
        </div>
      );
    default:
      return null;
  }
}
